import { render } from "./ShowDivisionalChart.vue?vue&type=template&id=34a6d604&scoped=true"
import script from "./ShowDivisionalChart.vue?vue&type=script&lang=js"
export * from "./ShowDivisionalChart.vue?vue&type=script&lang=js"

import "./ShowDivisionalChart.vue?vue&type=style&index=0&id=34a6d604&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a6d604"]])

export default __exports__